<div class="payee-header-wrapper">
  <ng-template #logoTemplate>
    <a
      href="https://payee.tech"
      target="_blank"
    >
      <img
        src="assets/shared/global-images/payee-logos/v1/black-payee-with-badge.svg"
        width="100px"
        alt="Payee"
      />
    </a>
  </ng-template>

  <div class="payee-header-logo">
    <ng-container [ngTemplateOutlet]="headerLogoTemplateRef || logoTemplate"></ng-container>
  </div>
  <div class="payee-header-content">
    <ng-content></ng-content>
  </div>
  <payee-dropdown
    width="auto"
    [isBorderButton]="false"
    [options]="['help', 'contact', 'intro']"
  >
    <ng-template #menuDisplayTemplate>
      {{ "PAYEE_HEADER.HELP" | translate }}
    </ng-template>
    <ng-template
      #itemDisplayTemplate
      let-option
    >
      @if (option === "help") {
        <a
          class="help-option"
          href="https://help.payee.tech/hu/"
          target="_blank"
        >
          {{ "PAYEE_HEADER.KNOWLEDGE_BASE" | translate }}
        </a>
      }
      @if (option === "contact") {
        <a
          class="help-option"
          href="https://www.payee.tech/contact"
          target="_blank"
        >
          {{ "PAYEE_HEADER.CUSTOMER_SERVICE" | translate }}
        </a>
      }
      @if (option === "intro") {
        <a
          class="help-option"
          href="https://payee.readme.io/reference/introduction"
          target="_blank"
        >
          {{ "PAYEE_HEADER.DOCUMENTATION" | translate }}
        </a>
      }
    </ng-template>
  </payee-dropdown>
  <payee-language-selector></payee-language-selector>
  @if (headerButtonTemplateRef) {
    <ng-container [ngTemplateOutlet]="headerButtonTemplateRef"></ng-container>
  }
</div>
